<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 v-loading="loading"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Nazwa formularza"
                                      :error="errors[addLanguageSuffix('name')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('name')]">
                            </el-input>
                        </el-form-item>
                        <edition-input v-model="form.edition"
                                       :errors="errors.edition"/>
                        <el-form-item label="Opis formularza"
                                      :error="errors[addLanguageSuffix('description')]">
                            <el-input v-model="form[addLanguageSuffix('description')]"
                                      type="textarea">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Tekst podziękowania"
                                      :error="errors[addLanguageSuffix('thanks')]">
                            <el-input v-model="form[addLanguageSuffix('thanks')]"
                                      type="textarea">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Adres email, na który będą wysyłane powiadomienia"
                                      :error="errors.notifications_email">
                            <el-input v-model="form.notifications_email">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Tekst na przycisku zatwierdzenia"
                                      :error="errors[addLanguageSuffix('button_text')]">
                            <el-input v-model="form[addLanguageSuffix('button_text')]">
                            </el-input>
                        </el-form-item>
                        <div v-if="!form.id || form.formdata_set.length === 0">
                          <sections :sections.sync="form.sections"
                                    :fieldTypes="fieldTypes"
                                    :errors="errors.sections || []"/>
                        </div>
                        <el-alert v-else title="Brak możliwości edycji sekcji" type="warning" show-icon>
                          Jeżeli formularz posiada już zgłoszenia nie można edytować jego pól.
                        </el-alert>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {CustomForm} from '@/api/';
    import EditionInput from '@/components/EditionInput'
    import Sections from '@/views/CustomForms/Sections'

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'CustomForms List'},
                form: {
                    sections: []
                },
                errors: {},
                service: CustomForm,
                fieldTypes: []
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.loading = true
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                    }).finally(() => {
                      this.loading = false
                    })
                }
                this.service.fieldTypes().then(response => {
                    this.fieldTypes = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const service = id ? this.service.update(id, this.form) : this.service.save(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        },
        components: {
            EditionInput,
            Sections
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// CustomForm.vue?c09bf6f0